(function () {
  if (!window.matchMedia('(max-width: 589px)').matches) return;

  document.querySelectorAll('[data-product-thumbs][data-position="beside"]').forEach(function (el) {
    el.dataset.position = 'below';
  });

  document.addEventListener('DOMContentLoaded', function () {
    var shareEl = document.getElementById('ProductImageShare');
    var mainPhotos = document.querySelector('.product__main-photos');
    if (shareEl && mainPhotos) {
      mainPhotos.parentNode.insertBefore(shareEl, mainPhotos.nextSibling);
    }
  });
})();
